import api from "./api";

// Online courses for missing skills, and the user's own courses (saved / started / completed).
export class CourseApiService {
    static ForSkill(skillId: number, occupationId: number, cvId: string, location = "Global") {
        return api.get("api/courses/for_skill", { params: { skill_id: skillId, occupation_id: occupationId, cvid: cvId, location } });
    }

    static CloseGap(occupationId: number, cvId: string, location = "Global") {
        return api.get("api/courses/close_gap", { params: { occupation_id: occupationId, cvid: cvId, location } });
    }

    static Counts(skillIds: number[]) {
        return api.get("api/courses/counts", { params: { skill_ids: skillIds.join(",") } });
    }

    static Plan() {
        return api.get("api/learning_plan");
    }

    // status: saved | completed | dropped | later (ask again in 2 weeks)
    static UpdatePlan(courseId: number, status: string, extra: Record<string, unknown> = {}) {
        return api.post("api/learning_plan", { course_id: courseId, status, ...extra });
    }

    // Open the course page now (synchronously, so it isn't blocked as a popup), then log the
    // click-out with the gap that led to it -- this is what marks the course "started".
    static Open(course: { course_id: number; url: string }, context: { occupation_id?: number; skill_id?: number } = {}) {
        const url = new URL(course.url);
        url.searchParams.set("utm_source", "topment");
        url.searchParams.set("utm_medium", "referral");
        window.open(url.toString(), "_blank", "noopener");
        return api.post(`api/courses/${course.course_id}/click`, context).catch(() => undefined);
    }
}
